import { render, staticRenderFns } from "./ArticleListCard.vue?vue&type=template&id=7adbcd2c&"
import script from "./ArticleListCard.vue?vue&type=script&lang=js&"
export * from "./ArticleListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default,UiIcon: require('/app/components/UI/UiIcon.vue').default})
